
const Utils = require('../utils/utils');

class VideoComponent {
    

    constructor(name, params) {
        this.defaults = {
            startLoad: true,
            loop: false,
            defaultMuted: false,
            volumeRatio: 1,
            /* muteDuration: 300*/
            hideDuration: 100,
            width: 1920,
            height: 1080,
            size: 'fillWidth'
        };

        this.name = name;
        this._params = Utils.extend(this.defaults, params);
        this._selector = this._params.selector;
        this._containerSelector = this._params.container;
        this._videoSRC = this._params.src || [];       // ARRAY, OBJECT {src: , type: } or STRING
        this._lastFixedProgress = -1;
        this._volumeValue = 1;
        this._init();
    }

    _init() {
        this._failed = false;
        this._lastFixedProgress = -1;
        this._muted = this._params.defaultMuted;

        this._container = document.querySelector(this._selector);
        const cont = document.querySelector(this._containerSelector);

        this._container.dataset.playing = false;
        this._container.dataset.buffering = false;
        this._container.dataset.firstBuffering = false;

        if (!this._container || !cont) return;

        cont.setAttribute('id', 'video_' + this.name);

        this._video = document.createElement('VIDEO');
        this._video.setAttribute('preload', 'none');
        if (this._params.loop)
            this._video.setAttribute('loop', 'loop');
        if (this._params.poster)
            this._video.setAttribute('poster', this._params.poster);
        else
            this._video.style.display = 'none';

        cont.appendChild(this._video);

        if (this._video.length < 1) {
            this._failed = true;
            return;
        }

        const _getSrc = (s, type) => {
            const src = document.createElement('SOURCE');
            src.setAttribute('src', s);
            if (type)
                src.setAttribute('type', type);
            return src;
        };

        let i, s;
        if (typeof this._videoSRC === 'string') {

            this._video.appendChild(_getSrc(this._videoSRC));

        } else if (typeof this._videoSRC.push === 'function') {

            for (i = 0; i < this._videoSRC.length; i++) {
                s = this._videoSRC[i];
                this._video.appendChild(_getSrc(s.src, s.type));
            }

        } else {
            this._video.appendChild(_getSrc(this._videoSRC.src, this._videoSRC.type));
        }

        this._src = [...this._video.querySelectorAll('source')];

        this.lr1 = _onCanplaythrough.bind(this);
        this.lr2 = _onCanplay.bind(this);
        this.lr3 = _onLoadstart.bind(this);
        this.lr4 = _onWaiting.bind(this);
        this.lr5 = _onUpdate.bind(this);
        this.lr6 = _onError.bind(this);
        this.lr7 = _onEnded.bind(this);
        this.lr8 = _onPlaying.bind(this);

        function _onCanplaythrough(evt) {
            // console.log(evt)
            _onCanplay.apply(this, [evt]);
        }

        function _onCanplay() {
            // console.log(evt)

            this._setCanplay();
        }

        function _onLoadstart() {
            // console.log(evt)
        }

        function _onUpdate() {
            let a;
            if (this._video && this._video.duration) {
                if (!this._container.dataset.playing || !this._playing) {
                    this._playing = true;
                }
                this.lr8();

                this._container.dataset.buffering = false;
                
                a = 100 * this._video.currentTime / this._video.duration;
                if (Math.floor(a / 25) > 0 && Math.floor(a / 25) > Math.floor(this._lastFixedProgress / 25)) {
                    if (this._progressInformCMD)
                        this._progressInformCMD.execute(25 * Math.floor(a / 25));
                    this._lastFixedProgress = a;
                }
            }
        }

        function _onWaiting() {
            // console.log(evt)
            this._setBuffering();
        }

        function _onPlaying() {
            // console.log(evt)
            this._video.dataset.playing = true;
            this._setPlaying();
        }

        function _onError(evt) {
            // console.log(evt)

            if (evt.currentTarget instanceof HTMLElement)
                evt.currentTarget.dataset.error = true;

            _checkErrors.apply(this);

        }

        function _checkErrors() {
            let i;
            let src;
            let n;
            for (i = 0, src, n = 0; i < this._src.length; i++) {
                src = this._src[i];
                if (src.dataset.error === true) n++;
            }
            if (!this._video.dataset.playing && n >= this._src.length)
                this._errorHandler();
        }

        function _onEnded() {
            // console.log(evt)

            if (Math.floor(this._lastFixedProgress / 25) < 100 / 25) {
                if (this._progressInformCMD)
                    this._progressInformCMD.execute(100);
                this._lastFixedProgress = 100;
            }

            this._completeHandler();
        }

        this._addVideoListeners(true);

        if (this._params.startLoad) {
            try {
                this._video.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }
    }

    start() {
        if (this._to) clearTimeout(this._to);

        this._video.style.display = 'block';
        this._playing = false;
        this._container.dataset.buffering = true;
        this._container.dataset.firstBuffering = true;

        if (this._played) {
            this._addVideoListeners(true);
            this._video.pause();
            this._video.currentTime = 0;
            this._lastFixedProgress = -1;
        }

        if (this._params.startLoad || this._played) {

            if (!this._failed) {
                try {
                    if (this._playInformCMD)
                        this._playInformCMD.execute();
                    this._played = true;
                    this._video.volume = this._volumeValue * this._params.volumeRatio;
                    this._video.muted = this._muted;
                    this._video.play();
                } catch (e) {
                    this._errorHandler(e);
                }
            }
        } else {
            try {
                this._video.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }
    }

    unmute() {
        this._video.muted = this._muted = false;
    }

    mute() {
        this._video.muted = this._muted = true;
    }

    get volume() {
        return this._volumeValue;
    }

    set volume(value) {
        this._volumeValue = value;
        if (this._video) this._video.volume = this._volumeValue * this._params.volumeRatio;
    }

    get playing() {
        return !this._video.paused;
    }

    play() {
        if (this._video.paused)
            this._video.play();
    }

    pause() {
        if (!this._video.paused)
            this._video.pause();
    }

    updateOnResize(w, h) {
        const w1 = w;
        const h1 = h;
        let r = w1 / this._params.width;

        switch (this._params.size) {
            case 'cover':
                r = Math.max(r, h1 / this._params.height);
                break;
            case 'coverPTContain':
                // cover and 'contain' for portrait
                r = w >= h ? Math.max(r, h1 / this._params.height) : Math.min(r, h1 / this._params.height);
                break;
            case 'contain':
                r = Math.min(r, h1 / this._params.height);
                break;
            case 'fillHeight':
                r = h1 / this._params.height;
                break;
        }

        this._video.setAttribute('width', Math.ceil(this._params.width * r) + 'px');
        this._video.setAttribute('height', Math.ceil(this._params.height * r) + 'px');

        this._video.style.top = Math.floor((h1 - Math.ceil(this._params.height * r)) / 2) + 'px';
        this._video.style.left = Math.floor((w1 - Math.ceil(this._params.width * r)) / 2) + 'px';
    }

    reset() {
        this._failed = false;
        this._playing = false;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = false;
        this._container.dataset.firstBuffering = false;
    }

    stop() {
        this._addVideoListeners(false);
        this._playing = false;
        this._started = false;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = false;
        this._container.dataset.firstBuffering = false;
        this._lastFixedProgress = -1;
        this._video.pause();
    }

    destroy() {
        if (this._to) clearTimeout(this._to);
        if (!this._video.parentNode)return;
        this._video.parentNode.removeChild(this._video);
    }

    hide(atOnce, destroy) {
        if (this._to) clearTimeout(this._to);
        if (!destroy) return;

        if (atOnce)
            this._destroy();
        else
            this._to = setTimeout(function () {
                this._destroy();
            }.bind(this), this._params.hideDuration * 1000);


    }
    
    _addVideoListeners(b) {
        if (this._hasListeners === b) return;
        this._hasListeners = b;

        if (b) {
            this._video.addEventListener('canplaythrough', this.lr1);
            this._video.addEventListener('canplay', this.lr2);
            this._video.addEventListener('loadstart', this.lr3);
            this._video.addEventListener('waiting', this.lr4);
            this._video.addEventListener('timeupdate', this.lr5);
            this._video.addEventListener('error', this.lr6);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++) {
                    this._src[i].dataset.error = false;
                    this._src[i].addEventListener('error', this.lr6);
                }
            }
            this._video.addEventListener('ended', this.lr7);

            if (this._video.readyState > 3) {
                this.lr1();
            } else if (this._video.readyState > 2) {
                this.lr2();
            }
        } else {
            this._video.removeEventListener('canplaythrough', this.lr1);
            this._video.removeEventListener('canplay', this.lr2);
            this._video.removeEventListener('loadstart', this.lr3);
            this._video.removeEventListener('waiting', this.lr4);
            this._video.removeEventListener('timeupdate', this.lr5);
            // this._video.removeEventListener('playing', this.lr1);
            this._video.removeEventListener('error', this.lr6);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++) {
                    this._src[i].removeEventListener('error', this.lr6);
                }
            }
            this._video.removeEventListener('ended', this.lr7);
        }
    }

    _setCanplay() {
        if (this._failed) return;


        if (this._started) {

            if (!this._failed && !this._playing) {
                try {

                    this._video.css({display: 'block'});
                    // this._container.classList.add(this._startClass);
                    if (this._playInformCMD)
                        this._playInformCMD.execute();
                    this._played = true;
                    this._started = true;
                    this._video.volume = this._volumeValue * this._params.volumeRatio;
                    this._video.muted = this._muted;
                    this._video.play();
                } catch (e) {
                    this._errorHandler(e);
                }
            }
        }
    }
    
    _setPlaying() {
        if (this._failed) return;
        this._container.dataset.playing = true;
        this._container.dataset.buffering = false;
        this._container.dataset.firstBuffering = false;
    }
    
    _setBuffering() {
        if (this._failed) return;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = true;
    }

    _completeHandler() {
        if (this._failed) return;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = false;
    }

    _errorHandler() {
        this._failed = true;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = false;
        this._container.dataset.firstBuffering = false;
    }

    setPlayInformCommand(cmd) {
        this._playInformCMD = cmd;
    }

    setProgressInformCommand(cmd) {
        this._progressInformCMD = cmd;
    }


}

module.exports = VideoComponent;



// WEBPACK FOOTER //
// ./js/viscom/viscomjs/video/VideoComponent.js